export default {
  statusRoot: { display: 'flex', alignItems: 'center' },
  statusLabel: {
    marginLeft: '5px'
  },
  icon: { fontSize: '18px' }
};
